import { LitElement, css, html } from 'lit';
import { TagCategoryDataType, TopicCategory, UserTag } from '../../../types';
import { customElement, property } from 'lit/decorators';

import { instanceOfTagGroup } from '../../../helpers/tags-categories';

@customElement('tags-categories-item')
export class TagsCategoriesItem extends LitElement {
    static amplitude_callsite: string = 'Edit Categories Drawer';

    @property({ type: Object })
    data: TopicCategory[] | UserTag[] = [];

    @property({ type: TagCategoryDataType })
    dataType: TagCategoryDataType = TagCategoryDataType.Category;

    onEditClick(data: TopicCategory | UserTag) {
        this.dispatchEvent(new CustomEvent('on-edit-click', {
            detail: {
                data
            }
        }));
    }

    onUpClick(index: number) {
        this.dispatchEvent(new CustomEvent('on-up-click', {
            detail: {
                dataType: this.dataType,
                index
            }
        }));
    }

    onDownClick(index: number) {
        this.dispatchEvent(new CustomEvent('on-down-click', {
            detail: {
                dataType: this.dataType,
                index
            }
        }));
    }

    renderIcon(c: TopicCategory | UserTag) {
        if (this.dataType === TagCategoryDataType.Category) {
            return html`<img class="tags-categories__item--image" src="${c.icon}" width="14" height="14">`;
        } else if (this.dataType === TagCategoryDataType.Tag && !instanceOfTagGroup(c)) {
            return html`<mwc-icon class="tags-categories__sell">sell</mwc-icon>`;
         } else {
            return html`<mwc-icon class="tags-categories__sell">sell</mwc-icon>
                        <mwc-icon class="tags-categories__sell tags-categories__sell--group">sell</mwc-icon>`;
        }
    }


    protected render() {
        return html`
            <div class="wrapper">
                ${this.data.map((c, index) => html`
                        <span class="item-wrapper">
                            <mwc-icon-button @click=${() => this.onEditClick(c)} icon="edit"></mwc-icon-button>
                            <span class="tags-categories__item">
                                ${this.renderIcon(c)}
                                ${c.name}
                            </span>
                            <mwc-icon-button @click=${() => this.onUpClick(index)} icon="arrow_upward" ?disabled=${index === 0}></mwc-icon-button>
                            <mwc-icon-button @click=${() => this.onDownClick(index)} icon="arrow_downward" ?disabled=${index === this.data.length - 1}></mwc-icon-button>
                        </span>`
                )}
            </div>
        `;
    }

    static get styles() {
        return css`
            mwc-icon-button {
                --mdc-icon-size: 16px;
                --mdc-icon-button-size: 30px;
            }

            .wrapper {
                display: flex;
                flex-direction: column;
            }

            .item-wrapper {
                display: flex;
                align-items: center;
                margin: 5px 0;
            }

            .tags-categories__sell {
                --mdc-icon-size: 14px;
                vertical-align: text-bottom;
            }

            .tags-categories__sell--group {
                margin-left: -11px;
            }

            .tags-categories__item {
                padding: 0 8px;
            }

            .tags-categories__item.tags-categories__item--group {
                background-color: #EFECF3;
            }

            .tags-categories__item.active {
                border: 3px solid var(--main-primary-color);
            }

            .tags-categories__item--image {
                vertical-align: text-bottom;
            }
        `;
    }
}
